import { render, staticRenderFns } from "./ResultSticker.vue?vue&type=template&id=449368dd&scoped=true&"
import script from "./ResultSticker.vue?vue&type=script&lang=ts&"
export * from "./ResultSticker.vue?vue&type=script&lang=ts&"
import style0 from "./ResultSticker.vue?vue&type=style&index=0&id=449368dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449368dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
